/* eslint-disable @typescript-eslint/no-explicit-any */
export class EnvironmentHelper {
    public static initEnvironment(environment: any): void {
        const configJson = (<any>window).environment?.envConfig;
        EnvironmentHelper.overwriteEnvironment(environment, configJson);
    }

    private static overwriteEnvironment(envJson: any, jsonObject: any): any {
        for (const key in jsonObject) {
            if (typeof jsonObject[key] === 'object' && jsonObject[key] !== null && !Array.isArray(jsonObject[key])) {
                this.overwriteEnvironment(envJson[key], jsonObject[key]);
                // eslint-disable-next-line no-prototype-builtins
            } else if (envJson.hasOwnProperty(key)) {
                envJson[key] = jsonObject[key];
            }
        }
        return envJson;
    }
}
